import { Field, Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';

import CoverField from '../../app/form/formik/cover';
import Button from '../../app/buttons';
import TextField from '../../app/form/formik/text';
import CollectionCover from 'collections/detail/cover/index';

const StyledForm = styled(Form)`
  display: grid;
  grid-gap: 8px;
  padding: 0px 20px;
  margin-bottom: 60px;
`;

const ProfileForm = ({ isValid, isSubmitting, avatarId }) => (
  <StyledForm>
    <Field name="avatar" component={CoverField} currentCover={avatarId} circular width={150} />
    <Field marginTop={3} name="first-name" component={TextField} label="First Name" width="100%" showError />
    <Field name="last-name" component={TextField} label="Last Name" width="100%" showError />
    <Button type="submit" width="max-content" backgroundColor="#9B59B6" disabled={!isValid || isSubmitting} style={{
      margin: 'auto', color: '#fff', borderRadius: '99px', position: 'absolute',
      padding: '0px 18px',
      top: '15px',
      right: '5px',
    }}>
      Save
    </Button>
  </StyledForm>
);

ProfileForm.propTypes = {
  avatarId: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

ProfileForm.defaultProps = {
  avatarId: '',
};

export default ProfileForm;
